module.exports = __webpack_public_path__ + "static/media/github-logo.8517e748.png";